import { createAction, props } from "@ngrx/store";
import { Environment } from "src/components/shared-components/class/general-classes/environment";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { EnvironmentStoreAction } from "src/components/shared-components/enum/enumStoreAction";

//#region Environment
/**
 * Reseet environment state and unset key storage
 */
export const environmentUnsetKeyStorageAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const environmentLoadInitStartAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_LOAD_INIT_START
);

/**
 * Action to load full list of environment
 */
export const environmentLoadListFromApiAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_LOAD_FROM_API
);

/**
 * Action to load last modified list of enviroment
 */
export const environmentLoadLastModifiedFromApiAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_LOAD_LAST_MODIFIED_FROM_API,
  props<{ environmentObject: GenericApiData }>()
);

/**
 * Action environment load success
 */
export const environmentLoadSuccessAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_LOAD_SUCCESS,
  props<{ environmentObject: GenericApiData }>()
);

/**
 * Action environment load error
 */
export const environmentLoadErrorAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_LOAD_ERROR,
  props<{ environmentObject: GenericApiData }>()
);
//#endregion

//#region Environment device
/**
 * Reseet environment device state and unset key storage
 */
export const environmentDeviceUnsetKeyStorageAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_DEVICE_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const environmentDeviceLoadInitStartAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_DEVICE_LOAD_INIT_START
);

/**
 * Action to load full list of environment
 */
export const environmentDeviceLoadListFromApiAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_DEVICE_LOAD_FROM_API
);

/**
 * Action to load last modified list of enviroment
 */
export const environmentDeviceLoadLastModifiedFromApiAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_DEVICE_LOAD_LAST_MODIFIED_FROM_API,
  props<{ environmentObject: GenericApiData }>()
);

/**
 * Action environment load success
 */
export const environmentDeviceLoadSuccessAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_DEVICE_LOAD_SUCCESS,
  props<{ environmentObject: GenericApiData }>()
);

/**
 * Action environment load error
 */
export const environmentDeviceLoadErrorAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_DEVICE_LOAD_ERROR,
  props<{ environmentObject: GenericApiData }>()
);
//#endregion

//#region Environment user Access Openable
/**
 * Acttion to unset key store action
 */
export const environmentAccessUserOpenableUnsetKeyStoreAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_ACCESS_USER_OPENABLE_UNSET_STORE_ACTION
);
/**
 * Action to load full list of environment open door command
 */
export const environmentAccessUserOpenableLoadListFromApiAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_ACCESS_USER_OPENABLE_LOAD_FROM_API
);

/**
 * Action environment access user openable load success
 */
export const environmentAccessUserOpenableLoadSuccessAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_ACCESS_USER_OPENABLE_LOAD_SUCCESS,
  props<{ listEnvironmentOpenDoorCommandObject: GenericApiData }>()
);

/**
 * Action environment access user openable load error
 */
export const environmentAccessUserOpenableLoadErrorAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_ACCESS_USER_OPENABLE_LOAD_ERROR
);
//#endregion

/**
 * Action environment access control start init load
 */
export const environmentAccessControlStartInitAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_ACCESS_CONTROL_LOAD_INIT_START
);

/**
 * Action environment access control load success
 */
export const environmetAccessControlLoadSuccessAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_ACCESS_CONTROL_LOAD_SUCCESS,
  props<{ listEnvironmentAccessControlMaitanance: GenericApiData }>()
);

/**
 * Action environment access control load error
 */
export const environmetAccessControlLoadErrorAction = createAction(
  EnvironmentStoreAction.ENVIRONMENT_ACCESS_CONTROL_LOAD_ERROR
);
